import React from 'react';
import s from './Purchases.module.scss';
import { ReactComponent as Checkbox } from 'images/new-icons/radiobutton.svg';
import { ReactComponent as CheckboxChecked } from 'images/new-icons/radiobutton-checked.svg';
import Button from 'components/shared/Button';

const reasons = [
  'Unpleasant Smell or Texture',
  'Color Mismatch',
  'Quality Issues',
  'Did Not Achieve Expected Results',
  'Expired or Spoiled Before Expiry Date',
  'Wrong Product Received',
  'Damaged Packaging',
];

const RefundReasons = ({ refundReasons, setRefundReasons }) => {
  return (
    <div className={s.refund_reasons}>
      <div className={s.refund_reasons_title}>Why do you need to refund?</div>
      <div className={s.refund_reasons_list}>
        {reasons.map(reason => (
          <div className={s.refund_reasons_list_item} onClick={() => setRefundReasons(reason)}>
            {refundReasons === reason ? <CheckboxChecked /> : <Checkbox />}
            <span>{reason}</span>
          </div>
        ))}
      </div>
     
    </div>
  );
};

export default RefundReasons;
